var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivestream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/livestream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/livestream",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,14.5996 L14.309,11.9996 L11.5,9.4006 L11.5,14.5996 Z M15.98,13.1787 L12.338,16.5487 C12.019,16.8447 11.604,16.9997 11.181,16.9997 C10.948,16.9997 10.711,16.9517 10.488,16.8547 C9.878,16.5887 9.5,16.0197 9.5,15.3697 L9.5,8.6297 C9.5,7.9807 9.878,7.4107 10.488,7.1457 C11.114,6.8707 11.841,6.9907 12.339,7.4517 L15.98,10.8217 C16.311,11.1267 16.5,11.5567 16.5,11.9997 C16.5,12.4437 16.311,12.8727 15.98,13.1787 M12,1.9997 C6.486,1.9997 2,6.4867 2,11.9997 C2,17.5137 6.486,21.9997 12,21.9997 C17.514,21.9997 22,17.5137 22,11.9997 C22,6.4867 17.514,1.9997 12,1.9997",
    id: "path-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivestream);
export default __webpack_public_path__ + "static/media/livestream.d577b221.svg";
export { ForwardRef as ReactComponent };